import cookie from 'js-cookie';

export const getCookies = () => ({
  guestToken: cookie.get('guestToken'),
  userToken: cookie.get('restricted_user_id'),
  locale: cookie.get('locale'),
  currency: cookie.get('currency'),
  countryIso: cookie.get('country_code'),
});

export const isUserLoggedIn = () => !!cookie.get('restricted_user_id');



// WEBPACK FOOTER //
// ./src/client/js/facades/eagle/helpers/cookies.js